module.exports = __webpack_public_path__ + "img/icon-search.c56f4699.svg";